import { Component, OnInit, OnDestroy } from "@angular/core";
import * as $ from "jquery";
import { CentralService } from "../servicios/central.service";
import {
  faSignInAlt,
  faKey,
  faEuroSign,
  faTractor,
  faMoneyBill,
  faFileInvoice,
  faUndo,
  faPrint,
  faFileAlt,
} from "@fortawesome/free-solid-svg-icons";
import { AvisosComponent } from "../avisos/avisos.component";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { Subject } from "rxjs";
import { Router } from "@angular/router";

@Component({
  selector: "app-anticipolis",
  templateUrl: "./anticipolis.component.html",
  styleUrls: ["./anticipolis.component.css"],
})
export class AnticipolisComponent implements OnInit, OnDestroy {
  dtOptions: any;
  dtTrigger: Subject<any> = new Subject();
  datosTabla: any = [{}];
  expandedIndex: number | null = null;

  icoEntr = faSignInAlt;
  icoKey = faKey;
  icoEur = faEuroSign;
  icoTra = faTractor;
  icoMny = faMoneyBill;
  icoInv = faFileInvoice;
  icoRet = faUndo;
  icoPrn = faPrint;
  icoFac = faFileAlt;

  fecdia: string;
  nomusu: string;
  menu: any;
  iconos = [
    this.icoKey,
    this.icoEur,
    this.icoTra,
    this.icoMny,
    this.icoInv,
    this.icoFac,
  ];

  resul: boolean;

  modoLis = 0;
  prifec: string;
  ultfec: string;

  constructor(
    private srvCentral: CentralService,
    private modalService: NgbModal,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.fecdia = Date().toLocaleString();
    this.nomusu = this.srvCentral.datosIden.UsuNom;

    /* Cargo tabla de menús */
    if (this.srvCentral.datosIden.UsuUsu !== "") {
      const k = this.srvCentral.listaMnu.length;
      this.menu = [];
      for (let i = 0; i < k; i++) {
        this.menu.push({
          nombre: this.srvCentral.listaMnu[i].nombre,
          ruta: this.srvCentral.listaMnu[i].ruta,
          icono: this.iconos[this.srvCentral.listaMnu[i].ico],
        });
      }
    }

    this.modoLis = this.srvCentral.EntModoLis;
    this.prifec = this.srvCentral.fechaCadena(this.srvCentral.gnPriDia);
    this.ultfec = this.srvCentral.fechaCadena(this.srvCentral.gnUltDia);
    this.cargaTabla();
  }
  toggleCard(i: number) {
    if (this.expandedIndex === i) {
      this.expandedIndex = null;
    } else {
      this.expandedIndex = i;
    }
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  persiana() {
    $("#wrapper").toggleClass("toggled");
  }

  cargaTabla(): void {
    this.dtOptions = {
      dom: "Blfrtip",
      buttons: [],
      ordering: false,
      responsive: true,
      language: {
        thousands: ".",
        decimal: ",",
        emptyTable: "No hay datos disponibles en la tabla",
        info: "Mostrando de _START_ a _END_ de _TOTAL_ registros",
        infoEmpty: "Mostrando de 0 a 0 de 0 registros",
        infoFiltered: "(filtrado de _MAX_ registros totales)",
        infoPostFix: "",
        lengthMenu: "Mostrar _MENU_ registros",
        loadingRecords: "Cargando...",
        processing: "Procesando...",
        search: "Buscar:",
        zeroRecords: "No se encontraron registros coincidentes",
        paginate: {
          first: "Primero",
          last: "Último",
          next: "Siguiente",
          previous: "Anterior",
        },
        aria: {
          sortAscending: ": activar para ordenar por columna ascendente",
          sortDescending: ": activar para ordenar por columna descendente",
        },
      },
    };
    this.cargaDatos();
  }

  cargaDatos() {
    this.resul = true;
    this.datosTabla = [];
    this.srvCentral
      .consulAnticipo(this.modoLis, this.prifec, this.ultfec)
      .subscribe((datos) => {
        if (datos[0].antFec === "?") {
          this.resul = false;
          const modalRef = this.modalService.open(AvisosComponent);
          modalRef.componentInstance.datAviso = {
            tit: "ERROR SERVIDOR",
            tex: datos[0].antErr,
            tip: 2,
            btcan: "",
            btno: "",
            btsi: "Aceptar",
          };
          modalRef.result.then((result) => {});
        } else {
          this.resul = false;
          this.datosTabla = [];

          for (const datitem of datos) {
            const regis = {
              tbEje: datitem.ttEje,
              tbSerAnt: datitem.ttSerAnt,
              tbNumAnt: datitem.ttNumAnt,
              tbFec: datitem.ttFecAnt,
              tbEjePar: datitem.ttEjePar,
              tbNumPar: datitem.ttNumPar,
              tbBasIva: datitem.ttBasIva,
              tbCuoIva: datitem.ttCuoIva,
              tbCuoReq: datitem.ttCuoReq,
              tbNeto: datitem.ttNeto,
              tbBasRet: datitem.ttBasRet,
              tbReten: datitem.ttReten,
              tbImpRet: datitem.ttImpRet,
              tbTotal: datitem.ttTotal,
              tbTex: datitem.ttTex,
              tbEjeLiq: datitem.ttEjeLiq,
              tbNumLiq: datitem.ttNumLiq,
              tbSerLiq: datitem.ttSerLiq,
            };
            this.datosTabla.push(regis);
          }
        }
        this.dtTrigger.next();
      });
  }

  volver(): void {
    this.router.navigate(["/anticipo"]);
  }

  documento(i: number): void {
    this.resul = true;
    this.srvCentral
      .documAnticipo(this.datosTabla[i].tbEje, this.datosTabla[i].tbAnt)
      .subscribe((datos) => {
        if (datos[0].antFec === "?") {
          this.resul = false;
          const modalRef = this.modalService.open(AvisosComponent);
          modalRef.componentInstance.datAviso = {
            tit: "ERROR SERVIDOR",
            tex: datos[0].antErr,
            tip: 2,
            btcan: "",
            btno: "",
            btsi: "Aceptar",
          };
          modalRef.result.then((result) => {});
        } else {
          this.resul = false;
          const tx = this.srvCentral.saca(datos[0].antFec);
          const url = this.srvCentral.UrlCave + "/" + tx;
          window.open(url, "_blank");
        }
      });
  }
}
